import { Component, Inject, OnInit } from '@angular/core';
import { ChecklistCategoriesVM } from '../../entities/global/model';
import { SafetyConfigService } from '../../services/safety-config.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-config-setup-checklist-edit-category-dialoglog',
  templateUrl: './config-setup-checklist-edit-category-dialoglog.component.html',
  styleUrls: ['./config-setup-checklist-edit-category-dialoglog.component.css']
})
export class ConfigSetupChecklistEditCategoryDialoglogComponent implements OnInit {

  constructor(public dialogRef:MatDialogRef<ConfigSetupChecklistEditCategoryDialoglogComponent>,
    private _safetyConfigService:SafetyConfigService,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

    selectedName:any;
    selectedDescription:any;
    categorylist:ChecklistCategoriesVM[]=[]
  ngOnInit() {
    this.getchecklist()
  }

  DialogClose(){
    this.dialogRef.close(false)
  }

  UpdateCategory(){
    let model= new ChecklistCategoriesVM()
    model.CategoryName=this.selectedName;
    model.CategoryDescription=this.selectedDescription
    model.ID=this.data.catId
   
    this._safetyConfigService.updateCategory(model).subscribe((res: any) =>{
 
  if(res){
    console.log('result', res)
    this.DialogClose();
   
  }
  
});}

getchecklist()
{
 this._safetyConfigService.GetAllCategoriesList().subscribe(res => {
  
   //this.questionlist=res[0].ChecklistQuestionsVM
   this.categorylist=res;
   if(this.categorylist.length>0)
   {
    this.categorylist.map(x=>{
      if( x.ID==this.data.catId){
        this.selectedName = x.CategoryName;
        this.selectedDescription=x.CategoryDescription
      }
    })
   }
 })
}
}
